export * from './components';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { Ticket } from '@reporting/rp-types/helpdesk';
import { componentFactories } from './factories';
import { HelpdeskSearchProvider } from './searchProvider';

export class HelpdeskApplication extends Application {

	async register(container: Container) {
		super.register(container);
		container.services.register('helpdesk');
		container.commands.registerProvider(new HelpdeskSearchProvider());
	}

	async init(container: Container) {
		super.init(container);
		container.services.register('users');
		container.services.register('accounting');
	}

	/** /{a}/helpdesk/{id_request} - the request link (also in the mails of p_HELP_SEND_MAIL) */
	async openPath(path: string) {
		const id = Number(path.split('/')[0]);
		if (!Number.isInteger(id) || id <= 0) return;
		// the list, not tickets/{id}: a request that does not exist or belongs to a company without the user's
		// helpdesk right is an empty result there, not a 404 the services raise their own alert about
		let tickets: Ticket[];
		try {
			tickets = await this.container.ms('helpdesk').get<Ticket[]>('tickets', {
				where: { id_request: id },
				fields: ['id_request', 'subject'],
			});
		} catch {
			return; // any other error has been alerted by the service already
		}
		const ticket = tickets?.[0];
		if (!ticket) {
			this.container.host.showAlert({ content: `${msg('Request not found.')} (#${id})`, type: 'warning' });
			return;
		}
		this.container.host.open(`helpdesk-ticket-${id}`, { title: ticket.subject });
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}
}
